export default __webpack_public_path__ + "static/media/linkedin.cfb62bfc.png";